import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EffectsModule } from '@ngrx/effects';
import { lobbyCheckInReducer } from './state/lobby-check-in.reducer';
import { StoreModule } from '@ngrx/store';
import { LobbyCheckInEffects } from './state/lobby-check-in.effects';
import { LobbyCheckInComponent } from './lobby-check-in.component';
import { DialogModule } from '@progress/kendo-angular-dialog';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import {CheckBoxModule} from '@progress/kendo-angular-inputs';
import { LobbyCheckInInputFilterDirective } from './check-in-input-filter.directive';
import { LocationSelectorModule } from '../../shared/modalpopup/location-selector/location-selector-module';
import { InstantImpersonateAssistComponent } from '../lobby-check-in/instant-impersonate-assist/instant-impersonate-assist.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [       
    LobbyCheckInComponent,
    LobbyCheckInInputFilterDirective,
    InstantImpersonateAssistComponent
   
  ],
  imports: [

    CheckBoxModule,
    CommonModule,
    DialogModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,    
    StoreModule.forFeature('lobbyCheckIn', lobbyCheckInReducer),
    EffectsModule.forFeature([LobbyCheckInEffects]),
    LocationSelectorModule,  
    TranslateModule
  ],
  exports: [   
    LobbyCheckInComponent,
    LobbyCheckInInputFilterDirective,
    LocationSelectorModule,
    TranslateModule
  ]
 
})
export class LobbyCheckInModule { }
